/**
 * Lightweight conditional logger.
 *
 * The widget is embedded on third-party sites, so we never log to the
 * console by default — that would pollute customer DevTools and leak
 * internal state. Logging is gated on the `data-debug` attribute of the
 * host element (or the URL query `?deepagent-debug=1`), letting us turn it
 * on remotely without re-deploying.
 */

const QUERY_FLAG = "deepagent-debug";

let cachedFlag: boolean | null = null;

export function isDebugEnabled(): boolean {
  if (cachedFlag !== null) return cachedFlag;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has(QUERY_FLAG)) {
      cachedFlag = params.get(QUERY_FLAG) !== "0";
      return cachedFlag;
    }
  } catch {
    // SSR or sandboxed iframe — fall through.
  }
  cachedFlag = false;
  return cachedFlag;
}

export const logger = {
  debug(...args: unknown[]): void {
    if (isDebugEnabled()) {
      // eslint-disable-next-line no-console
      console.debug("[deepagent-embed]", ...args);
    }
  },
  info(...args: unknown[]): void {
    if (isDebugEnabled()) {
      // eslint-disable-next-line no-console
      console.info("[deepagent-embed]", ...args);
    }
  },
  warn(...args: unknown[]): void {
    if (isDebugEnabled()) {
      // eslint-disable-next-line no-console
      console.warn("[deepagent-embed]", ...args);
    }
  },
  error(...args: unknown[]): void {
    // Errors always log — they help customers self-diagnose.
    // eslint-disable-next-line no-console
    console.error("[deepagent-embed]", ...args);
  },
};
